import { useMutation } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

import { useBidsListingQueryInvalidation } from './useSearchBidsQuery';

/**
 * This is to track the create or update bid status mutation keys in react query cache.
 */
const MUT_CREATE_BID_STATUS = 'create-bid-status-mutation-key';

/**
 * React Query mutation function for managing create or update bid api
 */
export const useManageBidMutation = () => {
  const { invalidateBidsListing } = useBidsListingQueryInvalidation();
  const {
    isPending,
    isError,
    error,
    data,
    mutate: createOrUpdateBid,
  } = useMutation({
    mutationKey: [MUT_CREATE_BID_STATUS],
    networkMode: 'always',
    mutationFn: BIDS_API.createBidStatusRequest,
    onSuccess: (_) => {
      invalidateBidsListing();
    },
  });

  return {
    error,
    isPending,
    isError,
    createOrUpdateBid,
    data,
  };
};
